var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZohoworkdrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M43.5,37.0237a2.1763,2.1763,0,0,1-2.1806,2.1717H6.6735A2.1762,2.1762,0,0,1,4.5,37.0165v-26.04A2.1762,2.1762,0,0,1,6.6806,8.8046v.0018h9.9013c2.257,0,6.2253,4.13,8.1881,4.2372H41.6783A1.8217,1.8217,0,0,1,43.5,14.8652Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 38.7664,
    cy: 22.9346,
    r: 3.0841
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 24.1933,
    cy: 28.5637,
    r: 3.0841
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 31.4798,
    cy: 25.7491,
    r: 3.0841
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.8785,39.1954V36.322a3,3,0,0,1,1.9229-2.8l5.07-1.95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M24.8992,39.1954V33.5835a3,3,0,0,1,1.9229-2.8l5.07-1.95"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.1857,39.1954V30.769a3,3,0,0,1,1.923-2.8l5.07-1.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZohoworkdrive);
export default __webpack_public_path__ + "static/media/Zoho workdrive.2e28d42eb2e38854c5bcfc999ab645de.svg";
export { ForwardRef as ReactComponent };